<template>
  <DashboardTemplate :navMenu="true">
    <div class="box-overflow dashboard">
      <div>
        <h3 class="text-left text-font-24 mg-y-less">Dashboard</h3>
      </div>
      <p class="text-left text-font-16">
        <span class="text-weight-600">สรุปรายชื่อผู้จบหลักสูตร</span> 
        <span > {{ course.name }}</span>
      </p>
      <div v-loading="loading" class="width-table">
        <ActivitySubjectDetailList
          v-if="course"
          :courseScoreList="courseScoreList"
          :courseId="courseId"
          :userId="userId"
          :showUpdatedAt="true"
          :subjectSuccess="course.subject.length == course.subjectNumber"
        />
      </div>
      
    </div>
  </DashboardTemplate>
</template>

<script>
import DashboardTemplate from "@/template/DashboardTemplate";
import DashboardDetailList from "@/components/dashboard/DashboardDetailList";
import ActivitySubjectDetailList from "@/components/activity/ActivitySubjectDetailList";

import { HTTP } from "@/service/axios.js";

export default {
  components: {
    DashboardTemplate,
    DashboardDetailList,
    ActivitySubjectDetailList
  },
  props: {
    routeParams: {
      type: Object,
      default: null,
    },
  },
  computed: {
    courseList(){
      return this.$store.state.courseList
    },
    token(){
      return this.$store.state.token
    }
  },
  data() {
    return {
      course:'',
      courseId:'',
      userId:'',
      type:'',
      loading:true,
      userList:[],
      courseScoreList:null
    };
  },
  mounted() {
    this.setParams()
    this.fetchCourseList()
    this.fetchPercentSubjects()
  },
  methods: {
    setParams() {
      if (this.routeParams != null) {
        if (typeof this.routeParams.courseId != "undefined") {
          this.courseId = this.routeParams.courseId;
          this.userId = this.routeParams.userId;
        }
      }
    },
    fetchCourseList() {
      let obj = {
        token: this.token,
      };
      this.$store.dispatch("FETCH_COURSE_LIST", obj);
      
      let filter = this.courseList.filter(
        (filter) => filter._id == this.courseId
      );

      if (filter.length > 0) {
        this.course = filter[0];
      }
    },
    fetchPercentSubjects() {
      let obj = {
        courseId: this.courseId,
        userId: this.userId,
      };

      HTTP.defaults.headers.common.Authorization = `Bearer ${this.token}`;
      HTTP.post(`percent/subjects`, obj)
        .then((res) => {
          if (res.data.success) {
            this.courseScoreList = res.data.obj;
          } else {
            this.courseScoreList = [];
          }
        })
        .catch((e) => {
          console.log("fetchPercentSubjects error", e);
        })
        .finally(() => {
          setTimeout(() => {
            this.loading = false;
          }, 500);
        });
    },
  },
};
</script>
